import { Printer } from '../masterdata/models/printer';
import { Template } from '../masterdata/models/template';

/**
 * NGS Print Request Class
 */
export class NGSPrintRequest {
  printer: Printer;
  plateType: string;
  numberOfBarcodes: number;
  labelType: string;
  cutsomPrefix: string;
  customFrom: string;
  customTo: string;
  template: Template
  barcodeList: string[];
}
